// extracted by mini-css-extract-plugin
export default {"header":"addProduct_header__k+OpT","save":"addProduct_save__zIwa6","notify":"addProduct_notify__hD9Tx"};